var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewfinderCosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "67935201-726C-429B-A172-1A7C8B94C49D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "investment-viewfinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-investment-attributes",
    transform: "translate(-812.000000, -259.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(135.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attributes",
    transform: "translate(145.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "costs",
    transform: "translate(448.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/viewfinder/costs",
    transform: "translate(60.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/costs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C8.92280425,0 0,8.92329657 0,20 C0,31.0767034 8.92329657,40 20,40 C31.0767034,40 40,31.0767034 40,20 C40,8.92329657 31.0767034,0 20,0 Z",
    id: "Shape",
    fill: "#F6AA33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1853813,18.0882969 C19.3794493,17.7941779 18.4392383,17.5000588 18.2377338,17.0588332 C18.1034118,16.7647142 17.9690898,16.2500012 18.5735345,15.8088509 C20.0511195,14.705881 21.461479,15.7353211 21.6629835,15.8823806 C22.2674282,16.3235592 23.073343,16.2500247 23.5434915,15.5882616 C24.01364,14.9264985 23.8792922,14.0441602 23.2748475,13.5294284 C22.7375595,13.0882498 21.864488,12.6470713 20.789912,12.4264585 L20.789912,11.4705952 C20.789912,10.6617631 20.1854673,10 19.446692,10 C18.7079167,10 18.103472,10.6617631 18.103472,11.4705952 L18.103472,12.7205775 C17.7676713,12.867637 17.3646967,13.0882216 17.028896,13.3823406 C15.551311,14.4853105 15.014023,16.4705434 15.7528155,18.2352576 C16.4915908,19.9264655 18.103472,20.4411974 19.3795525,20.8823289 C20.9914165,21.4705669 21.3944254,21.6911609 21.4615649,22.352924 C21.5287259,23.0882216 21.3272429,23.6029064 20.7899549,23.8970254 C19.849658,24.4852635 18.1035149,24.3382039 17.163218,23.5293813 C16.5587733,23.0146683 15.7528584,23.1617372 15.28271,23.8235003 C14.8125615,24.4852635 14.9469093,25.3676017 15.551354,25.8823336 C16.2901293,26.4705716 17.163218,26.8381969 18.1035149,27.0588097 L18.1035149,28.5294048 C18.1035149,29.3382369 18.7079596,30 19.4467349,30 C20.1855102,30 20.7899549,29.3382369 20.7899549,28.5294048 L20.7899549,27.0588097 C21.2600862,26.9117502 21.7302519,26.7646907 22.2003145,26.4705716 C23.610674,25.5882145 24.3494665,24.0441131 24.2151874,22.1322924 C24.0137001,19.3381145 21.7302519,18.602864 20.1855274,18.0881322 L20.1853813,18.0882969 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewfinderCosts);
export default __webpack_public_path__ + "static/media/viewfinder_costs.c78edf56adf783cd97b9a387ba6bd484.svg";
export { ForwardRef as ReactComponent };